"use client";
import { useState } from "react";
import { ProductCharacteristic } from "@/@types";
import ProductTabSpec from "./ProductTabSpec";
import ProductTabInfo from "./ProductTabInfo";
import ProductTabDocuments from "./ProductTabDocuments";
import ProductTabVideos from "./ProductTabVideos";
import ProductTabButton from "./ProductTabButton"

type Props = {
    features?: ProductCharacteristic[];
    info?: string;
    videos?: any;
    documents?: any;
};

export default function ProductTabs({ features, info, videos = [], documents = [] }: Props) {
    const [activeTab, setActiveTab] = useState("especificaciones");

    const handleTabChange = (tab: string) => setActiveTab(tab);

    return (
        <div className="hidden lg:block bg-white">
            <div className="container">
                <div className="mt-4 lg:mt-0 lg:pb-40 border-t">

                    {/* Tabs */}
                    <div className="flex flex-col sm:flex-row w-full border-gray01">
                        <ProductTabButton label="ESPECIFICACIONES" tabKey="especificaciones" activeTab={activeTab} onClick={handleTabChange} />
                        <ProductTabButton label="INFORMACION GENERAL" tabKey="info" activeTab={activeTab} onClick={handleTabChange} />
                        <ProductTabButton label="FOLLETOS" tabKey="docs" activeTab={activeTab} onClick={handleTabChange} />
                        <ProductTabButton label="VIDEOS" tabKey="videos" activeTab={activeTab} onClick={handleTabChange} />
                    </div>

                    {/* Contenido de la pestaña activa */}
                    <div className="bg-light00 pt-4 pb-4">
                        {activeTab === "especificaciones" && (
                            features && features.length > 0 ? (
                                <ProductTabSpec features={features} />
                            ) : (
                                <p className="font-bold">Sin información de especificaciones</p>
                            )
                        )}

                        {activeTab === "info" && (
                            info ? (
                                <ProductTabInfo info={info} />
                            ) : (
                                <p className="font-bold">Sin información de información general</p>
                            )
                        )}

                        {activeTab === "docs" && (
                            documents.length > 0 || videos.length > 0 ? (
                                <ProductTabDocuments documents={documents} />
                            ) : (
                                <p className="font-bold">Sin información de folletos</p>
                            )
                        )}

                        {activeTab === "videos" && (
                            documents.length > 0 || videos.length > 0 ? (
                                <ProductTabVideos videos={videos} />
                            ) : (
                                <p className="font-bold">Sin información de videos</p>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
